import React from 'react'
import {teamSiteUrlFormate} from "../../../utils/dateFormate";
const SecondBookSubMenuTheme = props => {
    const{subMenuArr}=props;
    const imagePath = window.weeksWebCloudConfig.REACT_APP_IMAGEURL;

        return(
            <div className={`bg-base container-fluid sub-menu-container d-none d-lg-block ${props.showSubMenu ? "open" : ""}`}>
                <div className="row">
                    <div className="col-md-11 offset-md-1">
                        <div className="row">
                    <div className="col-md-7 py-5">
                       <div className="subtitle mb-3">{subMenuArr.SearchInfo.TitleText}</div>
                       <div className="row">   
                           {
                               subMenuArr.SearchInfo.ImageContainer.map(data=>{
                                   return(
                                    <a className="col-md-5 floating-menu" href={teamSiteUrlFormate(data.URL)}>
                                            <img src={imagePath+data.Image} className="shadow-2" alt=""/>
                                            <span className="py-3 primary-sub-menu display-4">{data.DisplayText}</span> 
                                    </a>
                                   )
                               })
                           }
                            </div>   
                    </div>
                    
                     <div className="col-md-5 pt-7">
                      <ul className="secondary-sub-menu">
                      {
                        subMenuArr.Links.map(data=>{
                        return(<li className="p-2 mb-2"><a href={teamSiteUrlFormate(data.URL)}>{data.DisplayText}</a></li>)
                        })   
                    }
                      </ul>
                    </div>
                    </div> 
                </div>
                </div>
            </div>
        )
}

export default SecondBookSubMenuTheme;
